import React, { Component } from "react";
import Select from "react-select";

class Taco extends Component {
  render() {
    const { rule, setWidgetFilter } = this.props;

    const tacoOptions = [
      { value: "page", label: "Anytime the page matches" },
      { value: "include", label: "Always" }
    ];

    // taco defaults to "page" mode when widgetFilter is missing
    const tacoOption = rule.widgetFilter || "page";
    const tacoEnabled = ["page", "include"].includes(tacoOption);

    return (
      <div>
        <div className="option">
          <label className="radio">
            <input
              type="checkbox"
              onClick={() => {
                if (tacoEnabled) {
                  setWidgetFilter(rule.id, "exclude");
                } else {
                  setWidgetFilter(rule.id, "page");
                }
              }}
              checked={tacoEnabled}
            />
            Show this flow in Launchpad
          </label>
        </div>
        {(() => {
          if (tacoEnabled) {
            return (
              <div className="content">
                <Select
                  className="select-widget-filter"
                  clearable={false}
                  value={tacoOption}
                  options={tacoOptions}
                  autosize={false}
                  onChange={({ value }) => {
                    setWidgetFilter(rule.id, value);
                  }}
                />
              </div>
            );
          }
          return null;
        })()}
      </div>
    );
  }
}

export default Taco;
